import { reactive } from '@vue/composition-api';
import { currentUserId } from '@/store/useAuth';

export const state = reactive({
  show: false,
  domains: [
    //  {
    //  id: Number
    //  }
  ]
});

export const togglePanelShow = status => {
  console.log('toggle!')
  if (status !== undefined) {
    state.show = status;
  } else {
    state.show = !state.show;
  }
  drawerState.showDrawer = false;
};

export const setDomainView = ({ domainId, view }) => {
  const domain = state.domains.find(d => d.id == domainId);
  domain.panel = view;
};

export const selectDomains = domainIds => {
  const domains = [];

  if (!domainIds) {
    //  we are clearing the panel
    state.domains = [];
    togglePanelShow(false);
    return;
  }

  if (state.domains.map(d => d.id).includes(domainIds[0])) {
    //  not switching, just toggle panel
    togglePanelShow();
    return;
  }
  drawerState.showDrawer = false;
  domainIds.forEach(d => {
    domains.push({
      id: d,
      panel: currentUserId.value
    });
  });
  if (!state.show) {
    togglePanelShow(true);
  }

  state.domains = domains;
};

export const drawerState = reactive({
  showDrawer: false,
  domainId: null,
  viewUser: false,
  viewTrash: false
});

export const setDrawer = ({ domainId, viewUser = null, viewTrash = null }) => {
  if (domainId === false) {
    drawerState.showDrawer = false;
  } else {
    drawerState.showDrawer = true;
    drawerState.viewUser = viewUser;
    drawerState.viewTrash = viewTrash;
    if (domainId) {
      drawerState.domainId = domainId;
    }
  }
};
